import { axiosCall } from "@/utils/axiosCall";

let isId = (id) => !["creating", "error",'deleted', ""].includes(id);

export let deleteBusiness = async (businessId, dispatch) => {
  if (isId(businessId)) {
    await axiosCall({
      url: "Businesses/" + businessId,
      method: "delete",
    }).then(async () => {
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = "createdIds";
      payload["storeIndex"] = -1;
      payload["data"]["business"] = "deleted";
      await dispatch("setCreatedIds", payload);
    });
  }
};
export let deleteTag = async (tagsId, dispatch) => {
  await tagsId.map(async (tagId, index) => {
    if (isId(tagId)) {
      await axiosCall({
        url: "Tags/" + tagId,
        method: "delete",
      }).then(async () => {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = index;
        payload["data"]["tags"] = "deleted";
        await dispatch("setCreatedIds", payload);
      });
    }
  });
};
export let deleteBusinessTags = async (businessTagIds, dispatch, storeName) => {
  for (let i = 0; i < businessTagIds.length; i++) {
    const btid = businessTagIds[i];
    if (isId(btid)) {
      await axiosCall({
        url: "BusinessTags/" + btid,
        method: "delete",
      }).then(async () => {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = i;
        payload["data"][storeName] = "deleted";
        await dispatch("setCreatedIds", payload);
      });
    }
  }
};
export let deleteSnapshot = async (snapshotId, dispatch) => {
  if (isId(snapshotId)) {
    await axiosCall({
      url: "Snapshots/" + snapshotId,
      method: "delete",
    }).then(async () => {
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = "createdIds";
      payload["storeIndex"] = -1;
      payload["data"]["snapshot"] = "deleted";
      await dispatch("setCreatedIds", payload);
    });
  }
};
export let deleteAssessment = async (assessmentId, dispatch) => {
  if (isId(assessmentId)) {
    await axiosCall({
      url: "SelfAssessments/" + assessmentId,
      method: "delete",
    }).then(async () => {
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = "createdIds";
      payload["storeIndex"] = -1;
      payload["data"]["assessment"] = "deleted";
      await dispatch("setCreatedIds", payload);
    });
  }
};
export let deleteRoles = async (rolesIds, dispatch) => {
  for (let i = 0; i < rolesIds.length; i++) {
    const roleId = rolesIds[i];
    if (isId(roleId)) {
      await axiosCall({
        url: "AccountRoles/" + roleId,
        method: "delete",
      }).then(async () => {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = i;
        payload["data"]["roles"] = "deleted";
        await dispatch("setCreatedIds", payload);
      });
    }
  }
};

export let deleteAccessControls = async (rolesIds, dispatch) => {
  for (let i = 0; i < rolesIds.length; i++) {
    const roleId = rolesIds[i];
    if (isId(roleId)) {
      await axiosCall({
        url: "AccessControls/deleteAccessControlsByAccountRoleId/" + roleId,
        method: "get",
      }).then(async () => {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = i;
        payload["data"]["roleTemplates"] = "deleted";
        await dispatch("setCreatedIds", payload);
      });
    }
  }
};
export let deleteUsers = async (usersIds, dispatch) => {
  for (let i = 0; i < usersIds.length; i++) {
    const userId = usersIds[i];
    if (isId(userId)) {
      await axiosCall({
        url: "UserAccounts/" + userId,
        method: "delete",
      }).then(async () => {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = i;
        payload["data"]["users"] = "deleted";
        await dispatch("setCreatedIds", payload);
      });
    }
  }
};

export let deleteUsersRoles = async (userRolesIds, dispatch) => {
  for (let i = 0; i < userRolesIds.length; i++) {
    for (let j = 0; j < userRolesIds[i].length; j++) {
      const userRoleId = userRolesIds[i][j];
      await axiosCall({
        url: "UserAccountRoles/" + userRoleId,
        method: "delete",
      }).then(async() => {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = i;
        payload["storeSecondIndex"] = j;
        payload["data"]["userAccountRoles"] = 'deleted';
        await dispatch("setCreatedIds", payload);
      });
    }
  }
};
